import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getArticle } from "@/lib/api";
import { ArrowLeft, Clock } from "@phosphor-icons/react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getArticle(slug).then(setArticle).catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="blog-detail-error">
        <h1 className="font-display text-3xl text-ink">Article not found</h1>
        <Link to="/blog" className="mt-6 inline-block text-sm text-ink/70 hover:text-gold">← Back to journal</Link>
      </div>
    );
  }

  if (!article) {
    return <div className="max-w-3xl mx-auto px-6 py-32 text-ink/50">Loading…</div>;
  }

  return (
    <article data-testid="page-blog-detail">
      <header className="max-w-3xl mx-auto px-6 pt-16 pb-10">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-ink/60 hover:text-gold" data-testid="blog-back">
          <ArrowLeft size={14} /> Back to journal
        </Link>
        <p className="overline mt-8">{article.category}</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-ink leading-[1.08]">
          {article.title}
        </h1>
        <div className="mt-6 flex items-center gap-4 text-xs uppercase tracking-widest text-ink/50">
          <span>{article.author}</span>
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {article.read_minutes} min</span>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6">
        <div className="aspect-[16/9] rounded-3xl overflow-hidden ring-1 ring-ink/10">
          <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-16 prose prose-lg prose-neutral">
        {article.body.split("\n\n").map((p, i) => (
          <p key={i} className="text-lg leading-relaxed text-ink/80 mb-6">{p}</p>
        ))}
      </div>
    </article>
  );
}
